import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { startStripeCheckout } from "@/lib/payments";

export const CinematicLocked = ({ user }) => (
  <div className="flex flex-col items-center text-center gap-5 bg-white/90 backdrop-blur-md border border-[#E7DFD5] shadow-[0_8px_30px_rgba(44,39,32,0.06)] rounded-2xl max-w-xl mx-auto w-full p-10" data-testid="cinematic-locked">
    <Lock size={26} className="text-[#B45309]" strokeWidth={1.4} />
    <h3 className="font-display text-3xl">This room is for members.</h3>
    <p className="text-[#78716C] text-sm leading-relaxed">Unlock all 8 modules of the healing journey — Rich's voice, every reflection question, and your progress tracker.</p>
    {user ? (
      <button onClick={() => startStripeCheckout("bundle", user.id)} className="btn-ember text-sm" data-testid="cinematic-unlock-btn">
        Unlock the Bundle · $77
      </button>
    ) : (
      <Link to="/login" className="btn-ember text-sm" data-testid="cinematic-login-btn">Member login</Link>
    )}
  </div>
);
